import React from 'react';
import { GridItem, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ShelvesItem, TGetFinalizeShelfHelperParams } from 'domain/shelf-helper';
import { DeleteIcon } from '@chakra-ui/icons';
import { SalesWatchlistIcon } from 'components/Icons';
import { ShelvesTableRowCommon } from './ShelvesTableRowCommon';
import * as PATHS from 'constants/paths';
import { useHistory } from 'react-router-dom';

type ShelvesTableRowFinishedProps = {
  shelf: ShelvesItem;
  onDelete: (param: TGetFinalizeShelfHelperParams) => void;
};

export const ShelvesTableRowFinished: React.FC<ShelvesTableRowFinishedProps> = ({ shelf, onDelete }) => {
  const { t } = useTranslation('whisperme');
  const history = useHistory();

  return (
    <>
      <ShelvesTableRowCommon shelf={shelf} />
      <GridItem textAlign="center">
        <IconButton
          aria-label={t('SHELF_HELPER.SUMMARY_LABEL')}
          title={t('SHELF_HELPER.SUMMARY_LABEL')}
          size="sm"
          variant="outline"
          onClick={() => {
            history.push(`${PATHS.SHELF_HELPER.ROOT_SUMMARY.toPath()}?experimentId=${shelf.id}`);
          }}>
          <SalesWatchlistIcon />
        </IconButton>
        <IconButton
          aria-label={t('SHELF_HELPER.SHELVES.DELETE_SHELF_LABEL')}
          title={t('SHELF_HELPER.SHELVES.DELETE_SHELF_LABEL')}
          size="sm"
          variant="outline"
          onClick={() => {
            console.log('Just delete... with confirmation: ', shelf.id);
            onDelete({ experiment_id: shelf.id });
          }}>
          <DeleteIcon />
        </IconButton>
      </GridItem>
    </>
  );
};
